import './update-client-modal.controller.js';



// WEBPACK FOOTER //
// ./components/clients-list/update/index.js